module.exports = __webpack_public_path__ + "static/media/swingin time.1aa6c74b.jpg";